// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import { BOLD } from '../../../helpers/fontWeight';
import media from '../../../helpers/media/media';
import { zIndexMap } from '../../../helpers';

export default styled<any, Theme>('div')`
  align-items: center;
  background: ${props => props.theme.cartColumn.heading.background};
  color: ${props => props.theme.cartColumn.heading.color};
  display: flex;
  height: 4rem;
  z-index: ${zIndexMap.drawerColumnHeader};
  font-size: ${props => props.theme.cartColumn.heading.fontSize};
  font-weight: ${BOLD};
  justify-content: space-between;
  overflow: hidden;
  padding: 0 1.5rem;
  position: relative; /* IE fallback. Does not support sticky */
  position: sticky;
  top: 0;

  ${media.lg(css`
    display: none;
  `)}
`;
